import React, { useState, useEffect } from "react";
import Link from "gatsby-link";
import classNames from "classnames";
import "./styles.scss";
import EducationMenu from "../EducationMenu";
import NavMobile from "../NavMobile";
import Logo from "../../svgs/Logo";

const SiteHeader = ({ variant }) => {
    const [isScrolling, setIsScrolling] = useState(false);
    useEffect(() => {
        const listener = () => {
            setIsScrolling(window.scrollY > 10);
        };
        window.addEventListener(`scroll`, listener);
        return () => {
            window.removeEventListener(`scroll`, listener);
        };
    });

    return (
        <header
            className={classNames(`site-header`, {
                "site-header--light-on-dark":
                    variant === `light-on-dark` && !isScrolling,
                "site-header--scroll": isScrolling
            })}
        >
            <div className="inner site-header__inner">
                <div className="site-header__content">
                    <div className="site-header__logo">
                        <Link to="/" title="Go back home">
                            <Logo />
                        </Link>
                    </div>
                    <nav className="site-header__nav">
                        <ul className="site-header__nav-list">
                            <li className="site-header__nav-item">
                                <Link to="/" title="Go home">
                                    Home
                                </Link>
                            </li>
                            <li className="site-header__nav-item">
                                <Link
                                    to="/learn/articles"
                                    title="Read our articles"
                                >
                                    Blog
                                </Link>
                            </li>
                            <li className="site-header__nav-item">
                                <a
                                    href="https://invest.orcamoney.com/login"
                                    title="Schedule a call now"
                                    target="_blank"
                                >
                                    Login
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <div className="site-header__app-access">
                        <ul className="site-header__nav-list">
                            <a
                                className="site-header__nav-button"
                                href="https://app.hubspot.com/meetings/iain7"
                                title="Schedule a call now"
                                target="_blank"
                            >
                                <button className="btn-simple btn-sm btn-bordered">
                                    Get in touch
                                </button>
                            </a>
                        </ul>
                    </div>
                    <nav className="site-header__nav-mobile">
                        <NavMobile />
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default SiteHeader;
